<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="false" />
    <b-row>
      <b-col cols="12" lg="12">
        <b-card no-header>
          <template slot="header">Add New User</template>
          <b-row class="justify-content-md-center">
            <b-col cols="12" md="4">
              <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <label>Username *</label>
                    <b-form-input
                      v-model="user.username"
                      type="text"
                      id="username"
                      placeholder="Username"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <label>Name</label>
                    <b-form-input v-model="user.name" type="text" id="name" placeholder="Name"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <label>Country</label>
                    <b-form-select
                      v-model="user.country"
                      :options="countries"
                      value-field="country"
                      text-field="country"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <label>Age</label>
                    <b-form-input v-model="user.age" type="text" id="age" placeholder="Age"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <label>User Type</label>
                    <b-form-select v-model="user.type" :options="userTypes" :disabled="true"></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" md="4">
              <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <label>Password *</label>
                    <b-form-input
                      v-model="user.password"
                      type="password"
                      id="password"
                      placeholder="••••••••"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <label>Phone *</label>
                    <b-row>
                      <b-col cols="3">
                        <b-form-input
                          v-model="user.prefix"
                          type="text"
                          id="prefix"
                          placeholder="Prefix"
                        ></b-form-input>
                      </b-col>
                      <b-col cols="9">
                        <b-form-input
                          v-model="user.phone"
                          type="text"
                          id="phone"
                          placeholder="Phone"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <label>Gender</label>
                    <b-form-select v-model="user.gender" :options="genders"></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <label>Occupation</label>
                    <b-form-input
                      v-model="user.occupation"
                      type="text"
                      id="occupation"
                      placeholder="Occupation"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <label>User Role</label>
                    <b-form-select v-model="user.role" :options="userRoles" :disabled="true"></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="py-2 justify-content-md-center">
            <span style="color:red">{{msg}}</span>
          </b-row>
          <b-row class="justify-content-center">
            <div class="px-2">
              <b-button variant="outline-primary" size="sm" @click.prevent="inputCheck">Submit</b-button>
            </div>
          </b-row>
          <template slot="footer">
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ServerError: false,
      appLoading: false,
      user: null,
      msg: null,
      propic: null,
      proPicImg: null,
      genders: ["Male", "Female", "Others"],
      userTypes: ["Admin", "User"],
      userRoles: ["Admin", "Sub Admin"],
      countries: [],
      user: {
        username: null,
        password: null,
        name: null,
        country: "India",
        age: null,
        gender: "Male",
        prefix: null,
        phone: null,
        type: "Admin",
        role: "Sub Admin",
        occupation: null
      }
    };
  },
  beforeMount() {
    this.getCountry();
  },
  methods: {
    getCountry() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/country/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          this.countries = response.data.data;
        })
        .catch(err => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    inputCheck() {
      this.msg = null;
      if (
        !this.user.username ||
        !this.user.phone ||
        !this.user.prefix ||
        !this.user.password
      )
        this.msg = "Please Provide required Fields";
      else this.addUser();
    },
    addUser() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/adminregister",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        data: this.user
      })
        .then(response => {
          this.appLoading = false;
          if (response.data.status) {
            this.$router.push("/Users");
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch(err => {
          this.appLoading = false;
          this.ServerError = true;
        });
    }
  }
};
</script>
